import { isDevelopment, showDevTools } from "@/config/environmentUtils";

// Only use directly env variables here, do not use anything related to
// packages providers like React Query, etc. Because this helper
// can but used before app is inited (and the related providers). Also do
// not use `useFeature()` because it uses React Query in background.
export const shouldShowErrorToDeveloper = () => {
  return isDevelopment() && showDevTools();
};
